import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useCurrentPageStore = defineStore('currentPage', () => {
  // Properties that are set dynamically by the hydration process
  const url = ref('');
  const content = ref('');
  const backgroundColour = ref('');
  const title = ref('');
  const infoContent = ref('');

  return {
    url,
    content,
    backgroundColour,
    title,
    infoContent,
  };
});
